import moment from "moment"
import aramex from "../assets/ShippingCompaniesIcons/aramex.svg"
import dhl from "../assets/ShippingCompaniesIcons/dhl.svg"
import elite from "../assets/ShippingCompaniesIcons/elite.svg"
import fedex from "../assets/ShippingCompaniesIcons/fedex.svg"
import shopini from "../assets/ShippingCompaniesIcons/shopini-economy.svg"
import thabit from "../assets/ShippingCompaniesIcons/thabit.svg"
import ups from "../assets/ShippingCompaniesIcons/ups.svg"

export const getImageSrc = (service: string) => {
    let imageSrc = ""
    if (service.match("aramex")) imageSrc = aramex
    if (service.match("air express") || service.match("express worldwide")) imageSrc = dhl
    if (service.match("international economy") || service.match("international priority")) imageSrc = fedex
    if (service.match("shopini")) imageSrc = shopini
    if (service.match("air exports")) imageSrc = ups
    if (service.match("elite")) imageSrc = elite
    if (service.match("thabit")) imageSrc = thabit
    return imageSrc
}

export const numberFormatter = new Intl.NumberFormat("en-US", {
    maximumSignificantDigits: 16
})

export const insert = (arr: any[], index: number, item: any) => {
    arr.splice(index, 0, item)
}

export const countryNamesInEnglish =
    // @ts-ignore
    new Intl.DisplayNames(["en"], { type: "region" })

export const isDivisible = (num1: number, num2: number) => {
    return num1 % num2 === 0
}

export const arrayOfObjectsToObject = (arr: any[]) =>
    Object.assign(
        {},
        ...arr.map((item) => ({
            [Object.keys(item)[0]]: Object.values(item)[0]
        }))
    )

export const downloadFiles = (url: string) => {
    if (url && url !== "") {
        let linkElement = document.createElement("A") as HTMLAnchorElement
        linkElement.setAttribute("href", url)
        linkElement.setAttribute("download", url?.substr(url.lastIndexOf("/") + 1))
        linkElement.setAttribute("target", "_blank")
        document.body.appendChild(linkElement)
        linkElement.click()
        document.body.removeChild(linkElement)
    }
}

const changeTimeZone = (date: string, timeZone: string) => {
    return new Date(
        new Date(date).toLocaleString("en-US", {
            timeZone
        })
    )
}

export const dateFormatter = (date: string, showTime: boolean, country?: string) => {
    let convertedDate: Date = new Date(date)
    if (showTime && country) {
        let timeZone =
            country?.toLocaleUpperCase() === "CN"
                ? "Asia/Shanghai"
                : country?.toLocaleUpperCase() === "US"
                  ? "America/New_York"
                  : country?.toLocaleUpperCase() === "GB"
                    ? "Europe/London"
                    : country?.toLocaleUpperCase() === "TR"
                      ? "Asia/Istanbul"
                      : country?.toLocaleUpperCase() === "SA"
                        ? "Asia/Riyadh"
                        : "Asia/Dubai"

        convertedDate = changeTimeZone(date, timeZone)
    }
    return moment(convertedDate).format(showTime ? "DD MMM YYYY, h:mm A" : "DD MMM YYYY")
}

export const separateObject = (obj: Record<string, any>) => {
    const result = [] as Record<string, any>[]
    const keys = Object.keys(obj)
    keys.forEach((key: string) => {
        result.push({
            [key]: obj[key]
        })
    })
    return result
}
